import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import NewsSection from './components/NewsSection';
import ServicesPreview from './components/ServicesPreview';
import PricingPreview from './components/PricingPreview';

export default function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <NewsSection />
        <ServicesPreview />
        <PricingPreview />
      </main>
      <Footer />
    </>
  );
}
